export default 'M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24m3.94-14.56a1.5 1.5 0 0 1 2.12 2.12l-5 5a1.5 1.5 0 0 1-2.12 0l-5-5a1.5 1.5 0 0 1 2.12-2.12L12 13.38z';